import { LocalStorageValue } from './LocalStorageValue'
import { deserializeBool, serializeBool } from './local-storage-utils'

export class BooleanLocalStorageValue extends LocalStorageValue<boolean> {
  constructor(key: string, defaultValue?: boolean) {
    super(key, serializeBool, deserializeBool, defaultValue)
  }
}
